import React from 'react';

import { Card, Typography } from '@cfa/react-components';

import { getNameFromLanguage } from '@/utils/language';
import { cn } from '@/utils/tailwind';

import { LanguageObject } from '@/types/types';

import Constants from 'constants/index';

interface CategoryCardProps {
  categoryId: string;
  categoryName: LanguageObject | string;
  categoryIcon: string;
  onClick?: (categoryId: string) => void;
  'data-testid'?: string;
  className?: string;
}

const CategoryCard: React.FC<CategoryCardProps> = ({
  categoryId,
  categoryName,
  categoryIcon,
  onClick,
  'data-testid': dataTestId,
  className,
}) => {
  const name =
    typeof categoryName === 'string'
      ? categoryName
      : getNameFromLanguage(categoryName);
  return (
    <Card
      className={cn(
        'flex! flex-row! items-center! justify-start! border! p-4!',
        className,
      )}
      data-testid={dataTestId ?? `${categoryId}-card`}
      elevation={1}
      onClick={() => onClick?.(categoryId)}
    >
      <img
        className="mr-2 size-10"
        alt={`${name} icon`}
        src={Constants.PATHWAY_CDN_IMG.CATEGORIES + categoryIcon + '.svg'}
      />
      <Typography variant="body1" className="overflow-hidden! text-ellipsis!">
        {name}
      </Typography>
    </Card>
  );
};

export default CategoryCard;
